export default {
  computed: {
    currencyCode() {
      return this.$store.getters.currencyCode;
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    supportedGameProviders() {
      return ['AR', 'PGS', 'PP', 'JK', 'SP', 'JILI', 'PP-C', 'UU', 'NEXT', 'DB', 'WOW', 'AI', 'WF', 'OSG', 'EPW', 'SEXYBCRT', 'BI', 'ONLIVE', 'MTLIVE', 'FOXY'];
    },
    slotItems() {
      const CURRENCY_COMMON = ['CNY', 'IDR', 'MMK', 'MMO', 'JST', 'MYR', 'SGD', 'THB', 'USD'];
      const CURRENCY_PGS = ['CNY', 'MMK', 'IDR', 'THB', 'VND', 'KRW', 'USD'];
      const CURRENCY_EXTENDED = ['CNY', 'IDR', 'MMK', 'MMO', 'JST', 'MYR', 'SGD', 'THB', 'USD', 'VND'];
      const CURRENCY_DBHASH = ['CNY', 'IDR', 'MMK', 'MMO', 'JST', 'MYR', 'SGD', 'THB', 'USD'];
      const CURRENCY_JILI = ['JST', 'MYR', 'THB', 'USD'];
      const CURRENCY_JKR = ['CNY', 'IDR', 'JST', 'MYR', 'THB', 'USD'];
      const CURRENCY_PPG = ['CNY', 'IDR', 'JST', 'MYR', 'SGD', 'THB', 'USD', 'VND'];
      const CURRENCY_SPP = ['CNY', 'IDR', 'JST', 'MYR', 'SGD', 'THB', 'USD', 'VND'];

      const isCurrencyInList = (currencyList) => currencyList.includes(this.currencyCode);
      const isNotCurrencyInList = (currencyList) => !currencyList.includes(this.currencyCode);

      return [
        {
          mode: 13,
          code: 'EPW',
          image: 'slot/lobby_thumb-epicwin.jpg?v=12',
          icon: 'slot/icon/provider-logos/epic.png?v=12',
          textKey: 'ui.slot_epw',
          gameType: 1,
          shouldShow: isCurrencyInList(CURRENCY_COMMON)
        },
        {
          mode: 15,
          code: 'EPW',
          image: 'slot/lobby_thumb-epicwinmg.jpg?v=12',
          icon: 'slot/icon/provider-logos/epic-minigame.png?v=12',
          textKey: 'ui.slot_epwmg',
          gameType: 5,
          shouldShow: isCurrencyInList(CURRENCY_COMMON)
        },
        {
          mode: 12,
          code: 'WF',
          image: 'slot/lobby_thumb-wfgaming.jpg?v=12',
          icon: 'slot/icon/provider-logos/wf-gaming.png?v=12',
          textKey: 'ui.slot_wf',
          shouldShow: isCurrencyInList(CURRENCY_COMMON)
        },
        {
          mode: 0,
          code: 'OSG',
          image: 'slot/lobby_thumb-live22.jpg?v=12',
          icon: 'slot/icon/provider-logos/live22.png?v=12',
          textKey: 'ui.slot_live22',
          shouldShow: isCurrencyInList(CURRENCY_COMMON)
        },
        {
          mode: 7,
          code: 'UU',
          image: 'slot/lobby_thumb-uuslot.jpg?v=12',
          icon: 'slot/icon/provider-logos/uuslot.png?v=12',
          textKey: 'ui.slot_uusl',
          shouldShow: isCurrencyInList(CURRENCY_EXTENDED)
        },
        {
          mode: 9,
          code: 'DB',
          image: 'slot/lobby_thumb-dbhash.jpg?v=12',
          icon: 'slot/icon/provider-logos/dbg-slot.png?v=12',
          textKey: 'ui.slot_dbhash',
          shouldShow: !this.mmoMode && isCurrencyInList(CURRENCY_DBHASH)
        },
        {
          mode: 1,
          code: 'PGS',
          image: 'slot/lobby_thumb-pg.jpg?v=12',
          icon: 'slot/icon/provider-logos/pg.png?v=12',
          textKey: 'ui.slot_pgs',
          shouldShow: isCurrencyInList(CURRENCY_PGS)
        },
        {
          mode: 8,
          code: 'NEXT',
          image: 'slot/lobby_thumb-nextspin.jpg?v=12',
          icon: 'slot/icon/provider-logos/nextspin.png?v=12',
          textKey: 'ui.slot_next',
          shouldShow: isCurrencyInList(CURRENCY_COMMON)
        },
        {
          mode: 2,
          code: 'PP',
          image: 'slot/lobby_thumb-pramaticplay.jpg?v=12',
          icon: 'slot/icon/provider-logos/pragmatic.png?v=12',
          textKey: 'ui.slot_ppg',
          shouldShow: !this.mmoMode && isCurrencyInList(CURRENCY_PPG)
        },
        {
          mode: 4,
          code: 'JK',
          image: 'slot/lobby_thumb-joker.jpg?v=12',
          icon: 'slot/icon/provider-logos/joker.png?v=12',
          textKey: 'ui.slot_jkr',
          shouldShow: !this.mmoMode && isCurrencyInList(CURRENCY_JKR)
        },
        {
          mode: 5,
          code: 'SP',
          image: 'slot/lobby_thumb-simpleplay.jpg?v=12',
          icon: 'slot/icon/provider-logos/simpleplay.png?v=12',
          textKey: 'ui.slot_spp',
          shouldShow: !this.mmoMode && isCurrencyInList(CURRENCY_SPP)
        },
        {
          mode: 6,
          code: 'JILI',
          image: 'slot/lobby_thumb-jili.jpg?v=12',
          icon: 'slot/icon/provider-logos/jili.png?v=12',
          textKey: 'ui.slot_jili',
          shouldShow: !this.mmoMode && isCurrencyInList(CURRENCY_JILI)
        },
        {
          mode: 11,
          code: 'WOW',
          image: 'slot/lobby_thumb-wowgaming.jpg?v=12',
          icon: 'slot/icon/provider-logos/wow.png?v=12',
          textKey: 'ui.slot_wow',
          shouldShow: isCurrencyInList(CURRENCY_COMMON)
        }
      ].filter(slot => slot.shouldShow);
    },
    casinoSuites() {
      // Allowed currencies per suite — aligned with legacy drawer.vue casino submenu
      const CURRENCY_SUITE_SEXY = ['JST', 'MYR', 'SGD', 'THB', 'IDR', 'CNY', 'USD', 'MMK'];
      const CURRENCY_SUITE_YB = ['JST', 'MYR', 'SGD', 'THB', 'IDR', 'CNY', 'USD', 'MMK', 'HKD', 'KRW', 'VND'];
      const CURRENCY_SUITE_CT855 = ['JST', 'MYR', 'SGD', 'THB', 'IDR', 'CNY', 'USD', 'MMK', 'KRW', 'VND'];
      const CURRENCY_SUITE_SA = ['JST', 'MYR', 'SGD', 'THB', 'IDR', 'USD', 'MMK', 'VND'];
      const CURRENCY_SUITE_EVO = ['JST', 'MYR', 'SGD', 'THB', 'IDR', 'USD', 'MMK', 'KRW', 'VND'];
      const CURRENCY_SUITE_PRETTY = ['JST', 'MYR', 'SGD', 'THB', 'IDR', 'USD', 'MMK', 'VND'];
      const CURRENCY_SUITE_AI = ['JST', 'MYR', 'SGD', 'THB', 'IDR', 'CNY', 'USD', 'MMK'];
      const CURRENCY_SUITE_ONLIVE = ['JST', 'MYR', 'SGD', 'THB', 'IDR', 'CNY', 'USD', 'MMK'];
      const CURRENCY_SUITE_MTCASINO = ['MYR', 'IDR'];
      const CURRENCY_SUITE_FOXY = ['MYR', 'SGD', 'THB', 'IDR', 'CNY', 'USD'];


      const isCurrencyInList = (currencyList) => currencyList.includes(this.currencyCode);

      return [
        {
          id: 13,
          image: 'casino/lobby_thumb-onlive.jpg?v=12',
          icon: 'images/icon/casino/onlive.png',
          translationKey: 'ui.suite_onlive',
          // Available in MMK/MMO mode (legacy lobby had no mmoMode guard)
          shouldShow: isCurrencyInList(CURRENCY_SUITE_ONLIVE)
        },
        {
          id: 12,
          image: 'casino/lobby_thumb-sexy-bacarrat.jpg?v=12',
          icon: 'images/icon/casino/sexy-casino.png',
          translationKey: 'ui.suite_sexy',
          shouldShow: isCurrencyInList(CURRENCY_SUITE_SEXY)
        },
        {
          id: 9,
          image: 'casino/lobby_thumb-blive.jpg?v=12',
          icon: 'images/icon/casino/yeebet.png',
          translationKey: 'ui.suite_yb',
          shouldShow: false
        },
        {
          id: 4,
          image: 'casino/lobby_thumb-ct855.jpg?v=12',
          icon: 'images/icon/casino/ct855.png',
          translationKey: 'ui.suite_ct855',
          shouldShow: !this.brand && isCurrencyInList(CURRENCY_SUITE_CT855)
        },
        // {
        //   id: 1,
        //   image: 'casino/lobby_thumb-gameplay.jpg?v=12',
        //   icon: 'images/icon/casino/gameplay.png',
        //   translationKey: 'ui.suite_gp',
        //   shouldShow: !this.mmoMode
        // },
        {
          id: 3,
          image: 'casino/lobby_thumb-sa-gaming.jpg?v=12',
          icon: 'images/icon/casino/sa-gaming.png',
          translationKey: 'ui.suite_sa',
          shouldShow: !this.brand && isCurrencyInList(CURRENCY_SUITE_SA)
        },
        // {
        //   id: 7,
        //   image: 'casino/lobby_thumb-prettygaming.jpg?v=12',
        //   icon: 'images/icon/casino/pretty-gaming.png',
        //   translationKey: 'ui.suite_pg',
        //   shouldShow: !this.mmoMode && isCurrencyInList(CURRENCY_SUITE_PRETTY)
        // },
        // {
        //   id: 11,
        //   image: 'casino/lobby_thumb-casino.jpg?v=12',
        //   icon: 'images/icon/casino/ai_casino.png',
        //   translationKey: 'ui.suite_ai',
        //   shouldShow: !this.mmoMode && isCurrencyInList(CURRENCY_SUITE_AI)
        // },
        {
          id: 8,
          image: 'casino/lobby_thumb-evo.jpg?v=12',
          icon: 'images/icon/casino/evo.png',
          translationKey: 'ui.suite_evo',
          shouldShow: !this.mmoMode && !this.brand && isCurrencyInList(CURRENCY_SUITE_EVO)
        },
        {
          id: 14,
          image: 'casino/lobby_thumb-mtlive.jpg?v=12',
          icon: 'images/icon/casino/MT_casino.png',
          translationKey: 'ui.suite_mt',
          // shouldShow: false
          shouldShow: !this.mmoMode && !this.brand && isCurrencyInList(CURRENCY_SUITE_MTCASINO)
        },
        {
          id: 15,
          image: 'casino/lobby_thumb-foxy.jpg?v=12',
          icon: 'images/icon/casino/foxy.png',
          translationKey: 'ui.suite_foxy',
          shouldShow: false
        }
      ];
    }
  }
};

